import React from 'react';
import './NotreMission.css';
import { FaHandshake, FaUsers, FaHeart, FaUniversity, FaHome, FaBriefcase, FaGlobe, FaChartLine } from 'react-icons/fa';

const NotreMission = () => {
  const missions = [
    {
      id: 1,
      icon: <FaHandshake />,
      title: "Accompagner",
      description: "avec rigueur et bienveillance, les étudiants étrangers à chaque étape : admission, logement, visa, étude, séjour, démarches administratives, juridiction, emploi.",
      color: "#1e3c72",
      details: [
        "Admission universitaire",
        "Recherche de logement",
        "Procédures de visa",
        "Suivi académique",
        "Démarches administratives",
        "Conseil juridique",
        "Insertion professionnelle"
      ]
    },
    {
      id: 2,
      icon: <FaUsers />,
      title: "Faciliter leur intégration",
      description: "en leur offrant une connaissance des codes académiques, sociaux et professionnels.",
      color: "#dc143c",
      details: [
        "Cours de français adapté",
        "Ateliers culturels",
        "Coaching professionnel",
        "Réseautage social",
        "Accès aux ressources locales",
        "Mentorat par binôme"
      ]
    },
    {
      id: 3,
      icon: <FaHeart />,
      title: "Soutenir",
      description: "grâce à notre réseau solide de mentors, d'experts et de bénévoles, pour que personne ne traverse seul cette expérience.",
      color: "#2a5298",
      details: [
        "Soutien psychologique",
        "Mentorat individuel",
        "Communauté active",
        "Urgence 24/7",
        "Groupes de parole",
        "Accompagnement personnalisé"
      ]
    }
  ];

  return (
    <section className="mission-section" id="notre-mission">
      <div className="mission-background">
        <div className="mission-glow mission-glow-1"></div>
        <div className="mission-glow mission-glow-2"></div>
        <div className="mission-pattern"></div>
      </div>

      <div className="mission-container">
        {/* Header */}
        <div className="mission-header">
          <h2 className="mission-title">
            Notre mission
            <span className="mission-title-underline"></span>
          </h2>
          <p className="mission-subtitle">
            Plus qu'un accompagnement, un véritable partenariat vers la réussite
          </p>
        </div>

        {/* Missions Grid */}
        <div className="missions-grid">
          {missions.map((mission) => (
            <div className="mission-card" key={mission.id}>
              <div className="mission-card-inner">
                {/* Cercle de couleur avec icône */}
                <div className="mission-icon-circle" style={{ 
                  background: `linear-gradient(135deg, ${mission.color}, ${mission.color}dd)`,
                  boxShadow: `0 10px 30px ${mission.color}40`
                }}>
                  <div className="mission-icon">
                    {mission.icon}
                  </div>
                </div>

                {/* Titre et description */}
                <h3 className="mission-card-title" style={{ color: mission.color }}>
                  {mission.title}
                </h3>
                
                <p className="mission-card-description">
                  {mission.description}
                </p>

                {/* Détails en liste */}
                <div className="mission-details">
                  <ul className="details-list">
                    {mission.details.map((detail, index) => (
                      <li key={index} className="detail-item">
                        <span className="detail-dot" style={{ backgroundColor: mission.color }}></span>
                        <span className="detail-text">{detail}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Décorations */}
                <div className="mission-decoration" style={{ 
                  background: `linear-gradient(135deg, ${mission.color}15, transparent)`
                }}></div>
              </div>
            </div>
          ))}
        </div>

        {/* Chiffres clés */}
        <div className="mission-stats">
          <div className="stats-card">
            <div className="stats-icon">
              <FaUniversity />
            </div>
            <div className="stats-content">
              <div className="stats-number">60+</div>
              <div className="stats-label">Établissements partenaires</div>
            </div>
          </div>
          
          <div className="stats-card">
            <div className="stats-icon">
              <FaHome />
            </div>
            <div className="stats-content">
              <div className="stats-number">160</div>
              <div className="stats-label">Résidences étudiantes</div>
            </div>
          </div>
          
          <div className="stats-card">
            <div className="stats-icon">
              <FaBriefcase />
            </div>
            <div className="stats-content">
              <div className="stats-number">30+</div>
              <div className="stats-label">Entreprises partenaires</div>
            </div>
          </div>
          
          <div className="stats-card">
            <div className="stats-icon">
              <FaGlobe />
            </div>
            <div className="stats-content">
              <div className="stats-number">40+</div>
              <div className="stats-label">Nationalités accompagnées</div>
            </div>
          </div>
        </div>

        {/* Témoignage */}
        <div className="mission-testimonial">
          <div className="testimonial-content">
            <FaChartLine className="testimonial-icon" />
            <p className="testimonial-text">
              "Grâce à l'accompagnement d'ETEF, j'ai pu non seulement réussir mes études 
              mais aussi trouver un emploi en France. Leur soutien a été déterminant dans 
              mon parcours d'étudiant étranger."
            </p>
            <div className="testimonial-author">
              <span className="author-name">Mohamed D., étudiant en Master</span>
              <span className="author-origin">Maroc → Paris</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotreMission;